import { baseUrl } from "./baseUrl";

export const fetchWithAuthHandling = async (
  url: string,
  options: RequestInit
) => {
  const response = await fetch(url, options);
  if (response.status === 401) {
    const refreshResponse = await fetch(`${baseUrl}/auth/token/refresh`, {
      method: "POST",
      credentials: "include"
    });

    if (refreshResponse.ok) {
      return fetch(url, options);
    }
    throw new Error("Unauthorized and token refresh failed");
  }
  return response;
};
